import { render, staticRenderFns } from "./ProfileWizardPage.vue?vue&type=template&id=3938230e"
import script from "./ProfileWizardPage.vue?vue&type=script&lang=js"
export * from "./ProfileWizardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports